import { useMessages, useBlockTheme } from "@quillforms/renderer-core";


/**
 * WordPress Dependencies
 */
import { useEffect } from "react";

/**
 * External Dependencies
 */
import tinyColor from "tinycolor2";
import { css } from "emotion";
import classnames from "classnames";
import AutoComplete from "react-google-autocomplete";
import { useRendererStoreActions } from "@quillforms/renderer-core";


const ShortTextBlock = (props) => {
  const {
    id,
    attributes,
    setIsValid,
    setIsAnswered,
    setValidationErr,
    showNextBtn,
    val,
    setVal,
    showErrMsg,
    inputRef,
    isTouchScreen,
    setFooterDisplay,
    isPreview,
    isReviewing,
    innerBlocks,
  } = props;
  const messages = useMessages();
  const theme = useBlockTheme(attributes.themeId);
  const answersColor = tinyColor(theme.answersColor);
  const {
    // goNext,
    setFieldAnswer,
    setIsFieldValid,
  } = useRendererStoreActions();

  const {
    required,
    placeholder,
    googleMapsApiKey,
    cityInput,
    stateInput,
    zipInput,
  } = attributes;

  let skipValidation = false;

  const checkfieldValidation = (value) => {
    if (skipValidation) {
      skipValidation = false;
      return;
    }
    if (required === true && (!value || value === "")) {
      setIsValid(false);
      setValidationErr(messages["label.errorAlert.required"]);
    } else {
      setIsValid(true);
      setValidationErr(null);
    }
  };

  useEffect(() => {
    if (isPreview || !isReviewing) checkfieldValidation(val);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attributes]);

  // // Focus on mount
  // useEffect(() => {
  //   if (attributes.focusOnMount && inputRef.current) {
  //     setTimeout(() => {
  //       inputRef.current?.focus();
  //     }, 100);
  //   }
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [attributes.focusOnMount]);

  const changeHandler = (e) => {
    const value = e.target.value;
    setVal(value);
    showErrMsg(false);
    checkfieldValidation(value);
    if (value && value !== "") {
      setIsAnswered(true);
      showNextBtn(true);
    } else {
      setIsAnswered(false);
    }
  };

  return (
    <AutoComplete
      ref={inputRef}
      apiKey={googleMapsApiKey}
      options={{
        types: ["address"],
        componentRestrictions: { country: "us" }
      }}
      onPlaceSelected={(place) => {
        const streetNumber = place["address_components"].filter((component) => component.types.includes("street_number"))[0].long_name;
        const streetName = place["address_components"].filter((component) => component.types.includes("route"))[0].long_name;
        const city = place["address_components"].filter((component) => component.types.includes("locality"))[0].long_name;
        const state = place["address_components"].filter((component) => component.types.includes("administrative_area_level_1"))[0].short_name;
        const zip = place["address_components"].filter((component) => component.types.includes("postal_code"))[0].long_name;

        setVal(`${streetNumber} ${streetName}`);
        setFieldAnswer(cityInput, city);
        setIsFieldValid(cityInput, true);
        setFieldAnswer(stateInput, state);
        setIsFieldValid(stateInput, true);
        setFieldAnswer(zipInput, zip);
        setIsFieldValid(zipInput, true);
        // goNext();

        (document.querySelector(`[data-ref="${cityInput}"]`)).value = city;
        (document.querySelector(`[data-ref="${stateInput}"]`)).value = state;
        (document.querySelector(`[data-ref="${zipInput}"]`)).value = zip;
      }}
      className={classnames(
        css`
          & {
            width: 100%;
            border: none !important;
            border-radius: 0 !important;
            outline: none;
            padding-bottom: 8px;
            background: transparent;
            transition: box-shadow 0.1s ease-out 0s;
            box-shadow: ${answersColor.setAlpha(0.3).toString()} 0px 1px !important;
          }

          &::placeholder {
            opacity: 0.3;
            /* Chrome, Firefox, Opera, Safari 10.1+ */
            color: ${theme.answersColor};
          }

          &:-ms-input-placeholder {
            opacity: 0.3;
            /* Internet Explorer 10-11 */
            color: ${theme.answersColor};
          }

          &::-ms-input-placeholder {
            opacity: 0.3;
            /* Microsoft Edge */
            color: ${theme.answersColor};
          }

          &:focus {
            box-shadow: ${answersColor.setAlpha(1).toString()} 0px 2px !important;
          }

          color: ${theme.answersColor} !important;
          -webkit-appearance: none;
        `
      )}
      id={"short-text-" + id}
      placeholder={
        placeholder === false
          ? messages["block.shortText.placeholder"]
          : placeholder
      }
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          // get the next inner block
          const keys = innerBlocks.map((block) => block.id);
          const index = keys.indexOf(id);
          const nextBlock = innerBlocks[index + 1];
          if (nextBlock) {
            const nextBlockInput = document.getElementById(
              `short-text-${nextBlock.id}`
            );
            nextBlockInput.focus();
            e.stopPropagation();
            skipValidation = true;
          }
        }
      }}
      onChange={changeHandler}
      value={val ? val.toString() : ""}
      onFocus={() => {
        if (isTouchScreen) {
          setFooterDisplay(false);
        }
      }}
      onBlur={() => {
        if (isTouchScreen) {
          setFooterDisplay(true);
        }
      }}
      autoComplete="off"
    />
  );
};

export default ShortTextBlock;
